import React from "react"

const SlideShow = (props) => {

    return (
        <div>
            
        </div>
    )
}

export default SlideShow


// WEBPACK FOOTER //
// ./src/Components/SlideShow/SlideShow.js